import { createFileRoute, redirect } from '@tanstack/react-router';
import { ADMIN_SYSTEM_MONITOR_OVERVIEW } from '@/lib/constants/routes';

/**
 * Link vecchio del tab Redis: i dati di Redis stanno ora nella Panoramica
 * (riquadri e «Dettagli Redis»).
 */
export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/redis'
)({
  beforeLoad: () => {
    throw redirect({ to: ADMIN_SYSTEM_MONITOR_OVERVIEW, replace: true });
  },
});
